exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Modals-module__content___1IBev{display:grid;gap:1rem}", ""]);

// exports
exports.locals = {
	"content": "Modals-module__content___1IBev"
};